import Actions from './action'
import messageHub from './messageHub'

let currentDisposer = null

export function registerEventHandlers(inboxStore, todoCountStore) {
  if (currentDisposer) {
    try {
      currentDisposer()
    } catch (error) {
      console.error('[EventHandler] 清理旧注册时出错', error)
    }
    currentDisposer = null
  }

  const updateInbox = (payload = {}) => {
    if (inboxStore) {
      if (payload.unreadCount !== undefined) {
        inboxStore.updateUnreadCount(payload.unreadCount)
      } else {
        inboxStore.fetchUnreadCount({ debounce: true })
      }
    }
  }

  const disposers = []

  const handlers = {
    [Actions.TODO_UPDATED]: () => {
      todoCountStore.fetchTodoCount({ debounce: true })
    },
    [Actions.INBOX_MESSAGE_NEW]: (payload) => {
      updateInbox(payload)
      if (payload.msgType === 4) {
        todoCountStore.fetchTodoCount({ debounce: true })
      }
    },
    [Actions.INBOX_MESSAGE_UPDATED]: (payload) => {
      updateInbox(payload)
    }
  }

  Object.entries(handlers).forEach(([action, handler]) => {
    const dispose = messageHub.onEvent(action, (payload = {}) => {
      try {
        handler(payload)
        return true
      } catch (error) {
        console.error(`[EventHandler] 处理事件 ${action} 时出错`, error, payload)
        return false
      }
    })
    disposers.push(dispose)
  })

  const disposer = () => {
    disposers.forEach((dispose) => {
      try {
        dispose()
      } catch (error) {
        console.error('[EventHandler] 清理时出错', error)
      }
    })
    if (currentDisposer === disposer) {
      currentDisposer = null
    }
  }

  currentDisposer = disposer

  return disposer
}
